import React, { createContext, useContext, useEffect } from 'react';
import { ACTIVE_THEME } from '../theme/themeConfig';
import { getTheme } from '../theme/themeRegistry';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const currentTheme = getTheme(ACTIVE_THEME);

  useEffect(() => {
    document.body.setAttribute('data-theme', currentTheme.key);
  }, [currentTheme.key]);

  return (
    <ThemeContext.Provider value={{ currentTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
